/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import { useEffect, useRef } from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import objectPath from "object-path";

import KTToggle from "_metronic/_assets/js/toggle";
import * as builder from "_metronic/ducks/builder";
import { ReactComponent as AngleDoubleLeftIcon } from "_metronic/layout/assets/layout-svg-icons/Angle-double-left.svg";
import { ReactComponent as AngleDoubleRightIcon } from "_metronic/layout/assets/layout-svg-icons/Angle-double-right.svg";

const Brand = () => {
  const ktToggleRef = useRef();

  // Redux selectors using useSelector hook
  const brandClasses = useSelector((store) =>
    builder.selectors.getClasses(store, {
      path: "brand",
      toString: true,
    })
  );
  const asideSelfMinimizeToggle = useSelector((store) =>
    objectPath.get(store.builder.layoutConfig, "aside.self.minimize.toggle")
  );
  const headerLogo = useSelector((store) => builder.selectors.getLogo(store));

  useEffect(() => {
    const toggleOptions = {
      target: "body",
      targetState: "kt-aside--minimize",
      togglerState: "kt-aside__brand-aside-toggler--active",
    };

    new KTToggle(ktToggleRef.current, toggleOptions);
  }, []);

  return (
    <div
      className={`kt-aside__brand kt-grid__item d-flex justify-content-center ${brandClasses}`}
      id="kt_aside_brand"
    >
      <div className="kt-aside__brand-detail flex-grow-1">
        <Link to="">
          <div className="d-flex justify-content-center">
            <div>
              <img alt="logo" src={headerLogo} />
            </div>
            <div className="pl-10 text-dark d-flex align-items-center">
              <h4 className="m-0 font-weight-normal">
                <FormattedMessage id="APP.NAME" />
              </h4>
            </div>
          </div>
        </Link>
      </div>

      {asideSelfMinimizeToggle && (
        <div className="kt-aside__brand-tools d-none d-lg-block">
          <button ref={ktToggleRef} className="kt-aside__brand-aside-toggler" id="kt_aside_toggler">
            <span>
              <AngleDoubleLeftIcon />
            </span>
            <span>
              <AngleDoubleRightIcon />
            </span>
          </button>
        </div>
      )}
    </div>
  );
};

export default Brand;
